import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Alert, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import TextLoading from "../../../components/global/TextLoading";
import ContentButton from "../../../components/global/ContentButton";
import { DownloadCredentials } from "../../../api/Staff";

export default function ModalDownloadStaffCredentials({
  show,
  onHide,
  count,
  onConfirm,
  selectedRowIds,
}) {
  const [t] = useTranslation(["staff", "global"]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(false);

  useEffect(() => {
    Sentry.setTag("section", "Download Staff Credentials Modal");
  }, []);

  const handleConfirm = async () => {
    setLoading(true);
    const staffIds = selectedRowIds.map((row) => row.original.id);
    const payload = {};
    if (staffIds.length) {
      payload.user_ids = staffIds;
    }
    DownloadCredentials(payload).then((result) => {
      if (result && result.description) {
        Sentry.captureException(Error(JSON.stringify(result)));
        setErrors(result);
        setLoading(false);
        return;
      }
      onConfirm();
    });
  };

  return (
    <Modal
      id="modalDownloadStaffCredentials"
      show={show}
      size="md"
      aria-labelledby="contained-modal-title-lg"
    >
      <Modal.Header>
        <Modal.Title id="titleModalDownloadStaffCredentials">
          {t("staff:modalDownloadCredentials.title")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body id="modalDownloadStaffCredentialsBody">
        <Row>
          <Col md={12} id="messageModalDownloadStaffCredentials">
            {t("staff:modalDownloadCredentials.message", { count })}
          </Col>
        </Row>
        {errors && (
          <Row>
            <Col className="mt-3">
              <Alert id="alertErrorDownloadStaffCredentials" variant="warning">
                {errors?.description}
              </Alert>
            </Col>
          </Row>
        )}
      </Modal.Body>
      <Modal.Footer id="modalDownloadStaffCredentialsFooter">
        <ContentButton className="content-button" disabled={loading}>
          <Button
            id="cancelDownloadStaffCredentialsBtn"
            variant="outline-secondary"
            onClick={onHide}
            disabled={loading}
          >
            {t("global:buttons.cancel")}
          </Button>
          <Button
            id="confirmDownloadStaffCredentialsBtn"
            disabled={loading}
            onClick={handleConfirm}
          >
            {loading ? (
              <TextLoading
                text={t("global:buttons.processing")}
                variant="light"
              />
            ) : (
              t("global:buttons.accept")
            )}
          </Button>
        </ContentButton>
      </Modal.Footer>
    </Modal>
  );
}

ModalDownloadStaffCredentials.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  count: PropTypes.number,
  onConfirm: PropTypes.func,
  selectedRowIds: PropTypes.array,
};
